<script>
  import recuperarSenhaServico from './servico';

  export default {
    data() {
      return {
        usuario: {},
        mostrarErro: false,
        configuracao: this.$storage.configuracao(),
        mensagemErroUsuario: '',
        enviando: false,
      }
    },
    methods: {
      validar: function () {
        this.$validator.validateAll();

        if (!this.errors.any()) {
          this.recuperarSenha()
        }
      },
      retornaCaminhoVoltar() {
        if (this.$route.params.importacao) {
          return 'login.importacao'
        }
        else
          return 'login';        
      },
      recuperarSenha: function () {
        this.mostrarErro = false;
        this.enviando = true;

        recuperarSenhaServico.recuperar(this.usuario)
          .then(resposta => {
            this.$swal('', 'Senha enviada com sucesso para o email ' + resposta.body.email, 'info');

            if (this.$route.params.importacao) {
              this.$router.push('/login/importacao');
            } else {
              this.$router.push('/login');
            }
          })
          .catch(erro => {
            this.enviando = false;

            if (erro.status === 404) {
              this.mostrarErro = true;
              this.mensagemErroUsuario = 'Usuário não encontrado, entre em contato com a fundação.';
            } else {
              if (erro.status === 422) {
                this.mensagemErroUsuario = erro.body.message;

                this.mostrarErro = true;
              } else {
                this.$swal('', 'Ocorreu um erro ao recuperar senha, caso o erro persista entre em contato com a fundação.', 'error');
              }
            }
          });
      }
    },
    computed: {
    }
  }
</script>

<template>
  <div>
    <form class="m-t" role="form" @submit.prevent="validar">
      <div class="alert alert-danger" role="alert" v-show="mostrarErro">{{ mensagemErroUsuario }}</div>

      <div class="form-group" :class="{ 'has-error': errors.has('CPF') }">
        <input type="text"
               class="form-control"
               placeholder="CPF"
               name="CPF"
               id="cpf"
               v-model="usuario.login"
               v-validate="'required'"
               v-mascara="'cpf'">

        <p class="text-danger" v-if="errors.has('CPF')">{{ errors.first('CPF') }}</p>
      </div>

      <div slot="form-group" class="form-group">
        <router-link class="btn btn-default"
                     style="margin-bottom: 5px;width:140px;"
                     :disabled="enviando"
                     data-loading-text="<i class='fa fa-arrow-left'></i> Voltar"
                     :to='{ name: retornaCaminhoVoltar() }'>
          <i class="fa fa-arrow-left"></i>
          Voltar
        </router-link>

        <button type="button"
                class="btn btn-primary"
                :disabled="enviando"
                style="margin-bottom: 5px;width:140px;"
                data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Enviando..."
                @click="validar">
          <i class="fa fa-check"></i> Enviar
        </button>
      </div>

    </form>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/recuperar-senha/RecuperarSenha.vue